import { useSelector } from "react-redux";
import type { Airport } from "@b2bportal/air-shopping-api";
import { getAirports } from "@b2bportal/core-flights";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Trans } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import styles from "./styles.module.scss";

const getLocationLabel = (
  airportMap: Record<string, Airport> = {},
  airportCode: string
): string => {
  const { cityName = "" } = airportMap?.[airportCode] || {};

  return cityName ? `${cityName} (${airportCode})` : airportCode;
};

export const FlightTime = ({
  currentPointsText,
  currentPriceText,
  originalPointsText,
  originCode,
  destinationCode,
  departureTime,
  arrivalTime,
}) => {
  const [block, cn] = useModuleBEM(styles, "FlightDetails");
  const hasPoints = currentPointsText && currentPointsText !== "NaN";

  const airportMap = useSelector(getAirports);
  const originLabel = getLocationLabel(airportMap, originCode);
  const destinationLabel = getLocationLabel(airportMap, destinationCode);

  return (
    <div className={block}>
      <div className={cn("container")}>
        <div className={cn("time", { "departure-time": true })}>
          <span>{departureTime}</span>
          <span className={cn("location")}>{originLabel}</span>
        </div>

        <div className={cn("flight-time-icon")}>
          <Icon
            className={cn("airplane-icon")}
            iconName={IconNameEnum.airplane}
          />
        </div>

        <div className={cn("time", { "arrival-time": true })}>
          <span>{arrivalTime}</span>
          <span className={cn("location")}>{destinationLabel}</span>
        </div>
      </div>

      <div className={cn("price-container")}>
        <div className={cn("fiat")}>
          <span className={cn("from")}>
            <Trans
              i18nKey="pricesFrom"
              components={[<span className={cn("price")} />]}
              values={{
                price: currentPriceText,
              }}
            />
          </span>
          {hasPoints && <span> /</span>}
        </div>

        {hasPoints && (
          <div className={cn("points")}>
            <span>{currentPointsText}</span>
            {originalPointsText && (
              <span className={cn("strikethrough-points")}>
                {originalPointsText}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
